import React from 'react'
import Paper from '@material-ui/core/Paper'
import styles from './styles.scss'

export default (props) => <Paper className={styles.paper}>{props.children}</Paper>
